/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module SharedModule
 */

import {
    Component,
    ElementRef,
    Input,
    OnChanges,
    Renderer2,
    SimpleChanges,
    ViewChild,
} from '@angular/core';

import './full-modal-config-warnings.component.less';
import { IAlertObject } from 'ng/shared/components/avi-alert-group/avi-alert-group.component';

/**
 * @description Component to display configuration warnings on top of the modal.
 *
 * @author Shahab Hashmi
 */
@Component({
    selector: 'full-modal-config-warnings',
    templateUrl: './full-modal-config-warnings.component.html',
})
export class FullModalConfigWarningsComponent implements OnChanges {
    /**
     * Warning messages to be displayed.
     */
    @Input()
    public warnings: string[] = [];

    /**
     * Object to be passed with required props to AviAlertGroupComponent.
     */
    public warningList: IAlertObject[] = [];

    constructor(
        private elementRef: ElementRef,
        private renderer: Renderer2,
    ) {}

    /**
     * Reference to the alert group component, used to retrieve and set the height of the parent
     * div.
     */
    @ViewChild('alertGroup', { read: ElementRef })
    private readonly alertGroup: ElementRef;

    /** @override */
    public ngOnChanges(changes: SimpleChanges): void {
        changes.warnings?.currentValue.forEach((warning: string) => this.warningList.push({
            message: warning,
            status: 'warning',
        }));

        if (this.warningList.length > 0) {
            setTimeout(() => {
                const alertGroupHeight = this.alertGroup.nativeElement.offsetHeight;

                this.renderer.setStyle(
                    this.elementRef.nativeElement,
                    'height',
                    `${alertGroupHeight}px`,
                );
            });
        }
    }
}
